module.exports = __webpack_public_path__ + "img/cr1_3.23e02caf.png";